import React from "react";
import * as THREE from "three";

const MastColumnNone = ({ column, gridScale, colorList, luminaires }) => {
    const { height = 6, tilt, point, positionAngle } = column.values;
    const { x, y } = point;
    const radius = 0.2;
    const defaultBaseColor = "lightgray";
    const columnBaseZ = (height * gridScale) / 2;
    const { lanterns = [] } = column.values;
    const outreach = column.values.outreach || 0.75;

    const getOutreachWidth = (lantern) => {
        const useLanternOutreach = column.values.useLanternOutreach;
        const value = useLanternOutreach && lantern?.outreach != null
            ? lantern.outreach
            : outreach;
        return 0.75 * value;
    };

    return (
        <>
            <mesh
                position={[x * gridScale, y * gridScale * -1, columnBaseZ]}
                rotation={[Math.PI / 2, 0, 0]}
            >
                <cylinderGeometry
                    args={[radius * gridScale, radius * gridScale, height * gridScale, 32]}
                />
                <meshStandardMaterial color={defaultBaseColor} />
            </mesh>

            {lanterns.map((lantern, index) => {
                const mastAngle = positionAngle ?? 0;
                const angle = (lantern.positionAngle + mastAngle) % 360;
                const angleRad = -(angle - 90) * (Math.PI / 180);
                const tiltDeg = tilt ?? 0;
                const tiltRad = (tiltDeg * Math.PI) / 180;

                const direction = new THREE.Vector3(Math.cos(angleRad), Math.sin(angleRad), 0);

                const topOfColumn = [
                    x * gridScale,
                    y * gridScale * -1,
                    columnBaseZ + (height * gridScale) / 2 - 0.05,
                ];

                const luminaireIndex = luminaires.indexOf(lantern.luminaireId);
                const resolvedColor =
                    luminaireIndex !== -1 && colorList[luminaireIndex]
                        ? colorList[luminaireIndex]
                        : defaultBaseColor;

                let xRot = 0;
                let yRot = 0;
                const sector = Math.round(angle / 45) % 8;
                switch (sector) {
                    case 0: xRot = tiltRad; break;
                    case 1: xRot = tiltRad / Math.sqrt(2); yRot = -tiltRad / Math.sqrt(2); break;
                    case 2: yRot = -tiltRad; break;
                    case 3: xRot = -tiltRad / Math.sqrt(2); yRot = -tiltRad / Math.sqrt(2); break;
                    case 4: xRot = -tiltRad; break;
                    case 5: xRot = -tiltRad / Math.sqrt(2); yRot = tiltRad / Math.sqrt(2); break;
                    case 6: yRot = tiltRad; break;
                    case 7: xRot = tiltRad / Math.sqrt(2); yRot = tiltRad / Math.sqrt(2); break;
                }

                let inwardOffset = Math.sin(tiltRad) * (0.2 * gridScale) / 2;
                let upwardOffset = Math.sin(tiltRad) * (0.2 * gridScale) / 2;

                if (tilt < 0) {
                    inwardOffset *= -1;
                    upwardOffset *= -1;
                }

                const width = getOutreachWidth(lantern);
                const halfWidth = (width * gridScale) / 2;
                const baseOffset = direction.clone().multiplyScalar(halfWidth);

                return (
                    <mesh
                        key={index}
                        position={[
                            topOfColumn[0] + baseOffset.x - inwardOffset * direction.x,
                            topOfColumn[1] + baseOffset.y - inwardOffset * direction.y,
                            topOfColumn[2] - 0.1 + upwardOffset,
                        ]}
                        rotation={[xRot, yRot, angleRad]}
                    >
                        <boxGeometry
                            args={[width * gridScale, 0.2 * gridScale, 0.2 * gridScale]}
                        />
                        <meshStandardMaterial color={resolvedColor === '#212529' ? defaultBaseColor : resolvedColor} />
                    </mesh>
                );
            })}
        </>
    );
};

export default MastColumnNone;
